import { HelmetProvider } from 'react-helmet-async';

// Import i18n configuration
import './i18n';

import { AuthProvider } from './context/AuthContext';
import { RealmProvider } from './context/RealmContext';
import { FeedbackProvider } from './context/FeedbackContext';
import { TierProvider } from './contexts/TierContext';
import RealmRouter from './components/RealmRouter';
import { usePageViewTracking } from './hooks/usePageViewTracking';
import { useRouteTracking } from './hooks/useRouteTracking';
import { useGlobalOAuthHandler } from './hooks/useGlobalOAuthHandler';
import PostHogErrorBoundary from './components/ErrorBoundary/PostHogErrorBoundary';
import { VersionUpdateNotification } from './components/VersionUpdateNotification';
import './index.css';

function AppContent() {
  // Enable manual page view tracking
  usePageViewTracking();
  
  // Enable route tracking for debugging
  useRouteTracking();
  
  // Handle global OAuth flows (for authenticated users navigating away from login)
  useGlobalOAuthHandler();
  
  return (
    <>
      <RealmRouter />
      {/* Only show version checking in production or when explicitly needed */}
      {!import.meta.env.DEV && <VersionUpdateNotification />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <PostHogErrorBoundary>
        <AuthProvider>
          <TierProvider>
            <RealmProvider>
              <FeedbackProvider>
                <AppContent />
              </FeedbackProvider>
            </RealmProvider>
          </TierProvider>
        </AuthProvider>
      </PostHogErrorBoundary>
    </HelmetProvider>
  );
}

export default App;